module.exports = __webpack_public_path__ + "media/images/facebook-icon-b0a930a05707d76acc93aef8b5bbed9a.png";